
import ClassCollection from './index';

export default class Modules {
    private modules: any = {};
    private options: any;
    /**
     *
     * @param opts
     * @param opts.map
     * @param opts.basicComponents
     * @param opts.config
     */
    constructor(opts: any) {
        // super(opts);
        this.options = opts;
        this.modules.options = this.options;
    }
    /**
     * 创建组件
     * @param opts {Object}
     */
    public createComponents(opts: any = {}) {
        const ClassCol: any = ClassCollection;
        const routePlanningComponent = new ClassCol.RoutePlanningComponent({
            map: this.options.map,
            symbolConfig: this.options.symbolConfig,
            simpleRenderMgr: this.options.basicComponents.simpleRenderMgr,
            PointGeometryBuilder: this.options.basicComponents.PointGeometryBuilder,
            popupManager: this.options.basicComponents.popupManager,
            featureLocate: this.options.basicComponents.featureLocate,
            featureHighlight: this.options.basicComponents.featureHighlight,
            // service: searchServer,
            serviceConfig: this.options.serviceConfig,
            commandManager: this.options.basicComponents.commandManager,
            commandNotify: this.options.basicComponents.commandNotify,
        });
        this.modules.routePlanning = routePlanningComponent;
    }
    public initComponents(opts: any = {}) {
        this.createComponents(opts);
        return this.modules;
    }
}
